import { Delete, Pencil, Trash, ChevronDown } from 'lucide-react';
import {
  DotsHorizontalIcon,
} from "@radix-ui/react-icons";
import React from 'react'
import { HTTP } from '../../api/http-common';
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";

function VendorList({ member, fetchTableData }) {
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
          `business_cate/delete/${id}`,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
              fetchTableData()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };

  // const statusChange = (coupon_id,coupon_status) => {
  //   handleStatusChange(coupon_id,coupon_status);
  // };

  const statusChange = async (id, is_visible) => {
    const access_token = localStorage.getItem("access_token");
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };
      let fields = {
        update_status: Boolean(is_visible)
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure You want to make changes in the Vendor Visibility?",
        // text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.post(
          `vendors/update_status/${id}`,
          fields,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                icon: "success"
              });
              fetchTableData()
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };

  const handleApproveReject = async (id, status) => {
    const access_token = localStorage.getItem("access_token");
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };
      let fields = {
        status: status
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        // text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.post(
          `vendors/status/change/${id}`,
          fields,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
              fetchTableData()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };

  const handleEditVendor = async (id) => {
    navigate(`/vendors/${id}`);
  }

  return (
    <>
      <tr key={member.id}>
        {/* <td className="admin-table-th-td">{member.id}</td> */}
        <td className="admin-table-th-td">{member.first_name}</td>
        <td className="admin-table-th-td">{member.email}</td>
        <td className="admin-table-th-td">{member.business_name}</td>
        <td className="admin-table-th-td">{member.category_name}</td>
        <td className="admin-table-th-td">{member.contact_no}</td>
        <td className="admin-table-th-td">{member.plan_amount}</td>
        <td className="admin-table-th-td">{member.plan_type}</td>
        <td className="admin-table-th-td">{member.plan_start_date}</td>
        <td className="admin-table-th-td">{member.plan_expiration_date}</td>
        <td className="admin-table-th-td">
          <label className="admin-table-toggle-switch">
            <input
              type="checkbox"
              checked={member.is_visible === true} // Ensure it's a boolean comparison
              // onChange={() => statusChange(member.id, member.is_visible)} // Toggle is_visible
              onChange={() => statusChange(member.id, !member.is_visible)}
              className="admin-table-toggle-input"
            />
            <span
              className={`admin-table-slider ${member.is_visible ? "admin-table-slider-checked" : ""}`}
            >
              <span
                className={`admin-table-slider-before ${member.is_visible ? "admin-table-slider-checked-before" : ""}`}
              ></span>
            </span>
          </label>
        </td>

        <td className="admin-table-th-td">
          <div className="flex items-center">
            {/* <span className='text-[#6c1cff] pe-2'>
                <Link
                to={`/vendor/details/${member.id}`}>
                  <Pencil className='w-4 h-4'/>
                </Link>
              </span> */}


            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <DotsHorizontalIcon className="h-4 w-4" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-white border border-gray-200 rounded-md shadow-md py-2 w-56">
                {(member.verification_status === 3 || member.verification_status === 2) && (
                  <>
                    <DropdownMenuItem className="text-green-600 cursor-pointer" onClick={() => handleApproveReject(member.id, 1)}>
                      Approve
                    </DropdownMenuItem>
                    <DropdownMenuItem className="text-blue-600 cursor-pointer" onClick={() => handleEditVendor(member.id, 2)}>
                      Edit
                    </DropdownMenuItem>
                  </>
                )}
                {(member.verification_status === 3 || member.verification_status === 1) && (
                  <>
                    <DropdownMenuItem className="text-red-600 cursor-pointer" onClick={() => handleApproveReject(member.id, 2)}>
                      Reject
                    </DropdownMenuItem>
                    <DropdownMenuItem className="text-blue-600 cursor-pointer" onClick={() => handleEditVendor(member.id, 2)}>
                      Edit
                    </DropdownMenuItem>
                  </>
                )}

              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </td>
      </tr>
    </>
  )
}

export default VendorList